<template lang="pug">
.qmod-rangechart(:class="returnActiveCriter.id")
  .qmod-rangechart-chart
  .qmod-rangechart-sliders(:id="returnActiveCriter.id")
</template>

<script>
/* eslint-disable */
import noUiSlider from "nouislider";
import "nouislider/distribute/nouislider.css";

export default {
  name: "RangeChart",
  props: {
    activecritera: {
      type: Object,
      required: false,
      default: false,
    },
  },
  computed: {
    returnActiveCriter() {
      return this.activecritera;
    },
  },
  async mounted() {
    let HS = await this.$qModCore.HC();
    this.HS = HS;

    var data = this.returnActiveCriter.histogram.buckets;
    var catas = this.returnActiveCriter.histogram.steps;

    this.chart = this.HS.chart(
      this.$el.getElementsByClassName("qmod-rangechart-chart")[0],
      {
        chart: {
          margin: [0, 0, 0, 0],
          style: {
            overflow: "visible",
          },
        },
        tooltip: {
          enabled: true,
        },
        title: {
          text: null,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          // categories: catas,
          labels: {
            enabled: false,
          },
          tickLength: 0,
        },
        yAxis: [
          {
            type: "logarithmic",
            title: {
              text: null,
            },
            maxPadding: 0,
            minPadding: 0,
            gridLineWidth: 0,
            ticks: false,
            endOnTick: false,
            labels: {
              enabled: false,
            },
            // min: 0
            // max: 10
          },
        ],
        plotOptions: {
          series: {
            minPointLength: 5,
          },
        },

        series: [
          {
            name: "Histogram",
            type: "column",
            data: data,
          },
        ],
      }
    );

    var rangers = {};
    for (var i = 0; i < catas.length; i++) {
      var prozent = Math.ceil((100 / catas.length) * i);
      if (i == 0) {
        rangers["min"] = [catas[i]];
      } else if (i == catas.length - 1) {
        rangers["max"] = [catas[catas.length - 1]];
      } else if (i < catas.length - 1) {
        rangers[prozent + "%"] = [catas[i]]; //, catas[i + 1] - catas[i]
      }
    }

    console.log('this.returnActiveCriter ', this.returnActiveCriter);

    noUiSlider.create(
      this.$el.getElementsByClassName("qmod-rangechart-sliders")[0],
      {
        start: [
          this.returnActiveCriter.minRange,
          this.returnActiveCriter.maxRange,
        ],
        connect: true,
        range: rangers,
        // range: {
        //   catas,
        // },
        // range: {
        //   min: [catas[0]],
        //   max: [catas[catas.length - 1]],
        // },
      }
    );

    this.$el
      .getElementsByClassName("qmod-rangechart-sliders")[0]
      .noUiSlider.on("set", async (values, handle) => {
        let newObj = {
          id: this.returnActiveCriter.id,
          selectedmin: values[0],
          selectedmax: values[1],
        };
        // this.$store.commit("MarketScreener/UPDATE_ACTIVE_CRITERIA_LIST", [
        //   newObj
        // ]);

        await this.$store.dispatch(
          "MarketScreener/getEquityPreviewCount",
          newObj
        );
        await this.$store.dispatch("MarketScreener/getFilteredResults");

        this.$forceUpdate();
      });
  },
};
</script>

<style lang="stylus">
.qmod-rangechart
  width 200px
.noUi-horizontal .noUi-origin
  left auto
  right -25px
  top 15px
.qmod-rangechart-sliders
  background transparent
.qmod-rangechart-chart, .qmod-rangechart-sliders
  width 200px
  height 50px
  display inline-block
.qmod-rangechart-chart
  position absolute
  height 48px
  .highcharts-axis
    .highcharts-axis-line
      display none
.noUi-handle:after, .noUi-handle:before
  height 10px
  background #1976d2
  top 8px
.noUi-handle:before
  left 4px
.noUi-handle:after
  left 8px
.noUi-connect
  background rgba(171, 179, 178, 0.38)
  border-left 1px solid #1976d2
  border-right 1px solid #1976d2
.noUi-horizontal .noUi-handle
  width 15px
  left -13px
</style>
